module.exports = __webpack_public_path__ + "static/media/PlayButton.e7b15e49.svg";